export default __webpack_public_path__ + "static/media/img_example_header_logo.d982c2e8.png";